var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#AADD22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 22.2926L20 12.9996L15.586 8.58557L6.293 17.8786C6.16506 18.0067 6.07418 18.167 6.03 18.3426L5 23.5856L10.242 22.5556C10.418 22.5116 10.579 22.4206 10.707 22.2926ZM23 9.99957C23.3749 9.62452 23.5856 9.1159 23.5856 8.58557C23.5856 8.05524 23.3749 7.54663 23 7.17157L21.414 5.58557C21.0389 5.21063 20.5303 5 20 5C19.4697 5 18.9611 5.21063 18.586 5.58557L17 7.17157L21.414 11.5856L23 9.99957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c05a93337fbeaf8dc918b899a2eb5fc9.svg";
export { ForwardRef as ReactComponent };